import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUp, getTablebySql } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import { showDialog } from "@widgets/CommonDialog";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import SearchPanel, { ValueChangedEvent } from "@widgets/SearchPanel"; // 조회조건 Panel
import { Button } from "@mui/material";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

interface RowData {
  chk?: any;
  KeyField?: string;
  [key: string]: any;
}

const SN_SAL_SAO_REG_001_TEX_POP_01_OLD = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref) => {
    //#region Variable
    const { userInfo } = global();
    const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const gridApiRefL = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const searchRef = useRef<any>(null);
    const today = new Date();
    const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [column1, setColum1] = useState<any[]>([]);
    const [column2, setColum2] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any>();
    const [dataSource2, setDataSource2] = useState<RowData[]>([]);
    const [tpItem, setTpItem] = useState<any>();
    const [gridFocus, setGridFocus] = useState<boolean>();
    //#endregion

    //#region grid 길이 관련
    const cd_menu = modalRef?.cd_menu || "SN_SAL_SAO_REG_001_TEX_POP_01_OLD";
    const defaultSize = { panel1width: "49.5%", panel2width: "49.5%" };
    const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
    //#endregion

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        const modifiedRows = gridApiRefL.current?.getChange();
        let lsChk: any = "2";
        if (modifiedRows.modifiedRowcount === 0) {
          lsChk = "1";
        } else {
          lsChk = "2";
        }

        if (lsChk === "1") {
          return { flag: false, message: "변경된 내용이 없습니다." };
        }
        await onSave();
        return { flag: false };
      },

      getSelectedRow: () => [gridApiRefL.current.getSelectedRows() || []],
    }));

    useEffect(() => {
      gridApiRefH.current.selectAndFocusRow(0);
      setGridFocus(false);
      gridApiRefL.current.selectAndFocusRow(0);
      setGridFocus(false);
    }, [gridFocus]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp(
            "SN_SAL_SAO_REG_001_TEX_POP_01",
            {}
          );
          const savedTpItem = localStorage.getItem("tpItemValue");

          const mergedData: any = {
            ...rtn.formData,
            no_style: selectedData.no_style,
            tp_item: savedTpItem ? JSON.parse(savedTpItem) : undefined,
          };

          setFormData(mergedData);
          setFormControlData(rtn.formControlData);
          setColum1(rtn.grid.grid1);
          setColum2(rtn.grid.grid2);
          if (savedTpItem !== null) {
            setTpItem(JSON.parse(savedTpItem));
          }
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    useEffect(() => {
      if (tpItem !== undefined) {
        onSearch();
        localStorage.setItem("tpItemValue", JSON.stringify(tpItem));
      }
    }, [tpItem]);

    //#region onSearch
    const onSearch = async () => {
      try {
        const param = {
          id: "sn_sal_sao_reg_001_tex_pop_01_01",
          params: {
            cd_firm: userInfo.cd_firm,
            tp_item: tpItem,
          },
        };

        setDataSource1([]);
        setDataSource2([]);
        const data: any = await fnGetDataSet(param);

        if (data[0] && data[0].length > 0) {
          const strCdClasList = data[0].map((row: any) => row.cd_clas); // make array
          const strCdClas = strCdClasList.join(",");
          const noStyle = selectedData?.no_style;
          const param2 = {
            id: "sn_sal_sao_reg_001_tex_pop_01_02",
            params: {
              cd_firm: userInfo.cd_firm,
              cd_clas: strCdClas,
              no_style: noStyle,
            },
          };
          const data2: any = await fnGetDataSet(param2);
          setDataSource1(data[0]);
          setDataSource2(data2[0]);
          await new Promise((resolve) => setTimeout(resolve, 50));
          setGridFocus(true);
        } else {
          gridApiRefL.current.resetUpdate();
        }
      } catch (error) {}
    };
    //#endregion

    //region onSave
    const onSave = async () => {
      const dt: any[] = [];

      try {
        gridApiRefL.current.api.stopEditing();
        const modifiedRows = gridApiRefL.current?.getChange();
        const updatedRows = modifiedRows?.update || [];

        const filteredRows = updatedRows.filter(
          (row: any) =>
            row.chk === "Y" && (row.cd_firm === "" || row.cd_firm === null)
        );

        const deleteRows = updatedRows.filter(
          (row: any) => row.chk === "N" && row.cd_firm !== null
        );

        if (filteredRows.length === 0 && deleteRows.length === 0) {
          await showDialog("alter", "저장할 선택된 행이 없습니다.");
          return;
        }

        const no_style = selectedData.no_style || "";
        let maxLine = 0;
        updatedRows.forEach((row: any) => {
          const val = parseInt(row.no_line_config || "0", 10);
          if (!isNaN(val)) maxLine = Math.max(maxLine, val);
        });

        for (const row of filteredRows) {
          maxLine += 1;
          dt.push({
            ...row,
            cd_firm: userInfo.cd_firm,
            no_style,
            no_line_config: String(maxLine).padStart(4, "0"),
            chk: "Y",
          });
        }

        const masItemDelete: any[] = [];

        if (deleteRows.length > 0) {
          const grid1Data: any[] = [];
          const grid2Data: any[] = [];

          gridApiRefH.current.api.forEachNode((node: any) => {
            grid1Data.push(node.data);
          });

          gridApiRefL.current.api.forEachNode((node: any) => {
            grid2Data.push(node.data);
          });

          const combinations = generateAllCombinations(
            grid1Data,
            grid2Data,
            selectedData,
            "Y"
          );
          deleteRows.forEach((node: any) => {
            masItemDelete.push({
              cd_firm: userInfo.cd_firm,
              cd_item: no_style + node.cd_flag,
            });
          });
          const noStyle = selectedData.no_style;

          const deletedFlags = new Set(
            deleteRows
              .filter((row: any) => row.chk === "N")
              .map((row: any) => row.cd_flag)
          );

          combinations.forEach((combo: string) => {
            const flag = combo.replace(noStyle, "");

            const flagParts = flag.match(/.{1,3}/g) || [];

            if (flagParts.some((part) => deletedFlags.has(part))) {
              masItemDelete.push({
                cd_firm: userInfo.cd_firm,
                cd_item: combo,
              });
            }
          });
        }

        const SaveData = {
          mas_stylel_tex: {
            insert: dt,
            delete: deleteRows,
          },
          mas_item: { delete: masItemDelete },
        };

        await fnSave("SN_SAL_SAO_REG_001_TEX_POP_01_SAVE_O1", SaveData);
        gridApiRefL.current.resetUpdate();
      } catch (error: any) {}
    };
    //#endregion

    //#region onFocusedRowChanged
    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event;
      if (selectedRow) {
        const cd_clas = selectedRow.cd_clas;
        gridApiRefL.current.applyFilters({ cd_clas: cd_clas });
        gridApiRefL.current.selectAndFocusRow(0);
      } else {
        return;
      }
    };
    //#endregion

    const generateCombinations = (
      grid1Data: any[],
      grid2Data: any[],
      selectedData: any,
      ynItemcodeFilter: "Y" | "N",
      yn_chk: "Y" | "N"
    ): string[] => {
      const codeMap: Record<string, string[]> = {};
      const filteredGroups = grid1Data.filter(
        (group) => group.yn_itemcode === ynItemcodeFilter
      );

      filteredGroups.forEach((group) => {
        const codes = grid2Data
          .filter(
            (item) => item.cd_clas === group.cd_clas && item.chk === yn_chk
          )
          .map((item) => item.cd_flag);

        codeMap[group.cd_clas] = codes;
      });

      const combine = (arrays: string[][]): string[] => {
        if (!arrays.length) return [];
        return arrays.reduce((a, b) =>
          a.flatMap((x) => b.map((y) => `${x}${y}`))
        );
      };

      const orderedCodeLists = filteredGroups
        .map((group) => codeMap[group.cd_clas] || [])
        .filter((arr: string[]) => arr.length > 0);

      const noStyle = selectedData.no_style || "";
      return combine(orderedCodeLists).map((combo) => `${noStyle}${combo}`);
    };

    const generateAllCombinations = (
      grid1Data: any[],
      grid2Data: any[],
      selectedData: any,
      ynItemcodeFilter: "Y" | "N"
    ): string[] => {
      const codeMap: Record<string, string[]> = {};

      const filteredGroups = grid1Data.filter(
        (group) => group.yn_itemcode === ynItemcodeFilter
      );

      filteredGroups.forEach((group) => {
        const codes = grid2Data
          .filter((item) => item.cd_clas === group.cd_clas)
          .map((item) => item.cd_flag);

        codeMap[group.cd_clas] = codes;
      });

      const combine = (arrays: string[][]): string[] => {
        if (!arrays.length) return [];
        return arrays.reduce((a, b) =>
          a.flatMap((x) => b.map((y) => `${x}${y}`))
        );
      };

      const orderedCodeLists = filteredGroups
        .map((group) => codeMap[group.cd_clas] || [])
        .filter((arr: string[]) => arr.length > 0);

      const noStyle = selectedData.no_style || "";
      return combine(orderedCodeLists).map((combo) => `${noStyle}${combo}`);
    };

    //region onGrid1BtnsClick
    const onGrid1BtnsClick = async (id: string) => {
      try {
        if (id === "btnClick") {
          const grid1Data: any[] = [];
          const grid2Data: any[] = [];

          gridApiRefH.current.api.forEachNode((node: any) => {
            grid1Data.push(node.data);
          });

          gridApiRefL.current.api.forEachNode((node: any) => {
            grid2Data.push(node.data);
          });

          const noStyle = selectedData.no_style;
          const noStyleNm = selectedData.nm_style;
          const combinations = generateCombinations(
            grid1Data,
            grid2Data,
            selectedData,
            "Y",
            "Y"
          );

          if (combinations.length === 0) return;

          //const strJoin = combinations.join(",");

          const sqlQuery = {
            sql: "select cd_item from mas_item where cd_firm = :cd_firm and dc_dummy01 = :dc_dummy01;",
            cd_firm: userInfo.cd_firm,
            dc_dummy01: noStyle,
          };

          const findExistingData = await getTablebySql(sqlQuery);

          const existingItems = new Set(
            findExistingData.map((row: any) => row.cd_item)
          );

          const newCombinations = combinations.filter(
            (code) => !existingItems.has(code)
          );

          if (newCombinations.length === 0) {
            await showDialog("alter", "데이터가 이미 존재합니다.");
            return;
          }

          const masItemInsertList: any[] = [];
          for (let i = 0; i < newCombinations.length; i++) {
            const element = newCombinations[i];
            const updatedRow = {
              cd_firm: userInfo.cd_firm,
              cd_item: newCombinations[i],
              nm_item: element.replace(noStyle, noStyleNm),
              dc_item_unit: "EA",
              nm_model: noStyleNm,
              dc_dummy01: noStyle,
              cd_uer_reg: userInfo.cd_user,
              cd_mgmt1: searchRef.current.getFormdata().tp_item,
              fg_vat: "11",
              yn_bf: "Y",
              yn_phn: "N",
              yn_lot: "N",
              yn_sn: "N",
              yn_use: "Y",
              yn_iqc: "N",
              yn_eqc: "N",
              yn_pqc: "N",
              yn_autorcv: "N",
              yn_autobf_prd: "N",
              yn_inqc: "N",
              yn_longterm: "N",
              fg_item: "",
              fg_acct: "",
              tp_item: "",
              fg_domestic: "D",
              tp_policy: "L4L",
              tp_po: "MRP",
              dt_start: todayform,
              dt_end: "21001231",
              qt_unit_so: 1,
              qt_unit_po: 1,
              qt_max: 1,
              qt_min: 1,
            };
            masItemInsertList.push(updatedRow);
          }
          const SaveData = {
            mas_item: { insert: masItemInsertList },
          };
          await fnSave("SN_SAL_SAO_REG_001_TEX_POP_01_SAVE_O1", SaveData);
        }
      } catch (error: any) {}
    };

    //#region UI
    return (
      <div className="h-full flex flex-col">
        <div className="mb-1">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            onValueChanged={(event: ValueChangedEvent) => {
              const { colId, newValue } = event;
              if (colId === "tp_item") setTpItem(newValue);
            }}
          />
        </div>
        <div className="flex w-full h-full min-w-0 space-x-1.5">
          <SnResizable
            direction={"width"}
            seq={1}
            cd_menu={cd_menu}
            defaultSize={defaultSize}
            size={sizes.panel1width}
            onResizeStop={onResizeStop}
            enable={{ right: true }}
            minWidth={130}
          >
            <SnGrid
              menuInfo={modalRef}
              ref={gridApiRefH}
              seq={1}
              enableAddRow={true}
              columnConfig={column1}
              isEditable={false}
              rowData={dataSource1}
              onFocusedRowChanged={onFocusedRowChanged}
              rowSelection="single"
              title=""
              resizeController={{
                defaultSize: defaultSize,
                onResizeStop: onResizeStop,
              }}
            />
          </SnResizable>
          <SnResizable
            direction={"width"}
            seq={2}
            cd_menu={cd_menu}
            defaultSize={defaultSize}
            size={sizes.panel2width}
            onResizeStop={onResizeStop}
            enable={{ right: true }}
            minWidth={130}
          >
            <SnGrid
              menuInfo={modalRef}
              ref={gridApiRefL}
              seq={2}
              enableAddRow={true}
              isEditable={true}
              columnConfig={column2}
              rowData={dataSource2}
              rowSelection="single"
              title=""
              resizeController={{
                defaultSize: defaultSize,
                onResizeStop: onResizeStop,
              }}
            />
          </SnResizable>
        </div>
        <div className="flex justify-center gap-2 mt-4">
          <Button
            variant="contained"
            onClick={() => modalRef.current?.handleConfirm(true)}
            sx={{ width: 80 }}
          >
            저장
          </Button>
          <Button
            variant="outlined"
            onClick={() => modalRef.current?.handleConfirm(false)}
            sx={{ width: 80 }}
          >
            종료
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              onGrid1BtnsClick("btnClick");
            }}
            sx={{ width: 90 }}
          >
            코드생성
          </Button>
        </div>
      </div>
    );
  }
  //#endregion
);

export default SN_SAL_SAO_REG_001_TEX_POP_01_OLD;
